import React
,
{ 
	//useRef, 
	//useEffect,
	//useState 
} 
from "react";
import { connect } from "react-redux";


//import AHPIntro from "./AHPIntro";
//import AHPVariables from "./AHPVariables";
//import AHPMatrix from "./AHPMatrix";
import { CalciteModal, CalciteButton } from "@esri/calcite-components-react";

import quickViewImage1 from './images/quickView1.png';
import quickViewImage2 from './images/quickView2.png';
import pdfGuide from './RSSBP Quick Start Guide.pdf';

/**
 * 
 * @returns {React.Component}
 */
const QuickStartModal = ({active, CloseModal}) => {
	
	return (
		<CalciteModal active={active || undefined} onCalciteModalClose={CloseModal}>
			{/* Not sure why this isn't working */}
			<div slot="header" id="modal-title">RSSBP Database Quick Start Guide</div>
    		<div slot="content">
				<h2 style={{marginTop:'.25rem'}}>Welcome</h2>
				<p>
					Welcome to the RSSBP Disease Database Mapping tool.  
					This tools collects and collates shellfish disease from the Atlantic and Gulf Coasts allowing one to compare pathogen profiles among sites or explore disease patterns within a site. 
				</p>
				<div>
					<CalciteButton href={pdfGuide} target="_blank" iconStart="file-pdf">Download Quick Start Pdf</CalciteButton>
				</div>
				<h2>Quick View</h2>
				<p>
					&lsquo;Quick View&rsquo; reports and compares data from locations where publicly available data have been collected and integrated into the database. 
					Simply select a point of interest and it will show you the prevalence of pathogens from that site. 
				</p>
				<div>
					<ul>
						<li>Prevalence is the fraction of individuals with detectable infections (multiply by 100 to get the percent). </li>
						<li>Advance Prevalence is the fraction of individuals with heavy infections generally considered serious enough to reduce growth or cause mortality. </li>
						<li>Weighted prevalence is average infection intensity of all the animals sampled. </li>
					</ul>
				</div>
				<p>
					You can select a particular shellfish species and/or a particular shellfish pathogen as well as a time frame of data (most recent 3 yrs, 5 yrs or all) 
						using the menu that opens when you select &lsquo;Quick View&rsquo;.  
					In the popup box that appears when you select a point, &lsquo;Comparison&rsquo; will turn all other points green or red.  
					Green dots indicate an equal or lower prevalence relative to the site you selected (yellow dot).  
					Red squares indicate prevalence is greater than the site you selected. Click the &lsquo;X&rsquo; on the popup box to close it 
						if needed to see points behind it or simply move the map with your mouse.  
					Transfers from green dots to the yellow point represent relatively low biosecurity risk while transfers from red dots represent relatively higher biosecurity risk. 
					The actual levels at any point can be seen by simply clicking on the point of interest.  
					Transfers from green to yellow are generally acceptable, whereas transfers from red to yellow are generally not recommended, 
						however, risk is always a probability, not a guarantee, so all transfers should be carefully considered in collaboration with regulators and shellfish pathogen experts. 
				</p>
				<p>
					Here is an example showing a relatively low risk of exacerbating Perkinsus infections when oyster are transferred from upper Delaware Bay to the site selected in lower Delaware Bay whereas approximately half of the sites in Chesapeake Bay would represent a relatively higher level of risk.  
				</p>
				<div>
				<img style={{maxWidth:'100%'}} src={quickViewImage1} title="Quick View Image 1" alt="A screenshot of the map showing higher and lower prevalence locations in the Delaware Bay."/>
				</div>
				<p>To clear the data so that you can select a new point, scroll to the bottom of the menu and select &ldquo;Clear Selected Point&rdquo;:</p>
				<div>
				<img style={{maxWidth:'100%'}} src={quickViewImage2} title="Quick View Image 2" alt="A screenshot displaying the information about a chosen monitoring site showing the 'Clear Selected Point' button." />
				</div>
				<h2>Detailed View</h2>
				<p>
					&lsquo;Detailed View&rsquo;:  this view is for more advanced users and includes options to download publicly available data for independent analyses or to have the tool generate analyses of specific areas or comparisons among areas. 
				</p>
				<p>To Download Data simply select the regions to the level of specificity desired.  The tool will generate a csv file with the data in the format it is used within the tool.</p>
				<p>To Generate Reports, first select a region of interest down to the level of desired granularity.  A report can be generated at that point or a comparison location can be selected.  Reports will present data in tabular and graphical form for comparison. </p>
				<p>Maps and reports may be saved, printed and shared using the Save/Share/Print tool.</p>

				<p>Questions can be sent to <a href="mailto:info@rssbp.org">info@rssbp.org</a></p>
			</div>
			<CalciteButton slot="primary" color="blue" icon="chevron-left" width="full"onClick={CloseModal}>OK</CalciteButton>
		</CalciteModal>
	)
};

const mapStateToProps = (state) => ({
	
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(QuickStartModal);

/*
		<CalciteModal aria-labelledby="modal-title" active fullscreen>
    <div slot="header" id="modal-title">Modal title</div>
    <div slot="content">Modal content lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
        do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
        nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
    <CalciteButton slot="back" color="neutral" icon="chevron-left" width="full">Back
    </CalciteButton>
    <CalciteButton slot="secondary" width="full" appearance="outline">Cancel</CalciteButton>
    <CalciteButton slot="primary" width="full">Save</CalciteButton>
</CalciteModal>
*/
